/**
 * ProgressIndicator - Shows labeling progress
 *
 * Displays current position and completion statistics
 * Requirement: ES-REQ-017, ES-REQ-086
 */

import React from 'react';
import styled from 'styled-components';
import { useLabeling } from '@/context/labelingContext';

const Container = styled.div`
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
`;

const ProgressText = styled.div`
  font-weight: 500;
  margin-bottom: 4px;
`;

const SubText = styled.div`
  font-size: 12px;
  color: #666;
`;

export const ProgressIndicator: React.FC = () => {
  const { state } = useLabeling();
  const { feedback, currentIndex } = state;

  const total = feedback.length;
  const current = currentIndex + 1;
  const remaining = total - current;

  if (total === 0) {
    return (
      <Container>
        <ProgressText>No feedback items to label</ProgressText>
      </Container>
    );
  }

  return (
    <Container>
      <ProgressText>
        Item {current} of {total}
      </ProgressText>
      <SubText>
        {remaining} remaining
      </SubText>
    </Container>
  );
};

export default ProgressIndicator;
